/* eslint-disable prefer-destructuring */
import React, { useContext, useState, useEffect } from 'react';
import styled from 'styled-components';
import moment from 'moment-timezone';
import {
  VisitsGlobalContext,
  SET_VISIT_TYPE_OPTION,
  SET_START_TIME,
} from '@mummssoftware/global-context';
import {
  DATE_PICKER_SUGGEST_BOX_WIDTH_PX,
  ReactDatePicker,
  SuggestBox,
} from '@mummssoftware/common-ui';
import {
  momentToDate,
  utcToTz,
  dateToMoment,
} from '@mummssoftware/utils/dates';
import { isAgencyEnabled } from '@mummssoftware/utils/utils';
import { formatPimDate } from '@mummssoftware/utils/formatters';
import { VisitLogContext } from '../../../Context/VisitLogContext';
import { CHANGE_DETAIL } from '../../../Context/constants';
import { AppContext } from '../../../../context';
import defaults from '../../../../translations/en.json';

type EditDateProps = {
  pastVisit: Record<string, any>;
};
const EditDateDiv = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  width: 100%;
  align-items: flex-end;
`;
const VisitInterfaceDiv = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: flex-end;
  margin-bottom: 5px;
`;
const TextDiv = styled.div`
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  justify-content: center;
  font-weight: 400;
  font-size: 1rem;
  padding-right: 10px;
  padding-left: 10px;
  padding-bottom: 5px;
`;
export const SmallDiv = styled.div<{
  width: number;
  align?: string | null;
}>`
  width: ${(props) => `${props.width}px;`};
  ${(props) => (props.align ? `text-align: ${props.align}` : ``)}
  & * {
    font-size: 1rem;
  }
`;
export const EditDate = ({ pastVisit }: EditDateProps) => {
  const { visitTypeOptions, visitTypeOption, startTime } = useContext(
    VisitsGlobalContext,
  );
  const { dispatch } = useContext(VisitLogContext);

  const visitsGlobalContext = useContext(VisitsGlobalContext);

  const { currentUser, patient } = useContext(AppContext);
  const timezone = currentUser.siteTimezone || moment.tz.guess();
  const savedStartTime = pastVisit?.effectivedatetime
    ? utcToTz(pastVisit?.effectivedatetime, timezone)
    : new Date();
  // 15 min increment for selected agencies
  const increment30MinVisitBins: string = window.env
    ?.increment30MinVisitBins as string;
  const is30MinAgency = isAgencyEnabled(increment30MinVisitBins, currentUser);
  const [displayDate, setDisplayDate] = useState(savedStartTime);

  const hasHCPCS = pastVisit.physicianservices;
  const canEditVisitType = !hasHCPCS && !pastVisit?.isfacetofaceallowed;

  useEffect(() => {
    const payload = {
      id: pastVisit.id,
      label: pastVisit.visittype,
      value: pastVisit.visitdisplaytype,
    };
    visitsGlobalContext.dispatchVG({
      type: SET_VISIT_TYPE_OPTION,
      payload,
    });
  }, []);

  useEffect(() => {
    if (startTime) {
      const updatedTime = utcToTz(startTime as any, timezone);
      setDisplayDate(updatedTime);
    }
  }, [startTime]);

  const referralDate =
    patient && new Date((patient as mumms.patient).referralDate);
  const maxDate = moment(referralDate);

  const handleDateChange = (visitdate: any) => {
    setDisplayDate(visitdate);
    const visitDate = dateToMoment(visitdate); // dateToMoment splices out timezone
    const startDate = formatPimDate(visitDate);

    visitsGlobalContext.dispatchVG({
      type: SET_START_TIME,
      payload: startDate,
    });
  };
  const onVisitTypeChange = (visitType: any) => {
    visitsGlobalContext.dispatchVG({
      type: SET_VISIT_TYPE_OPTION,
      payload: visitType,
    });
    dispatch({
      type: CHANGE_DETAIL,
      payload: true,
    });
  };
  const pickerSelectedDate = () => {
    const time = moment.tz(new Date(), moment.tz.guess()).tz(timezone);
    const date = displayDate
      ? moment(displayDate).toDate()
      : momentToDate(time);
    return date;
  };
  return (
    <EditDateDiv id="edit-visit">
      <VisitInterfaceDiv id="edit-sub-visit">
        <TextDiv>{defaults.visitDate}</TextDiv>
        <ReactDatePicker
          dateFormat="MM-dd-yy"
          inputMargin="0 0 4px 0"
          inputWidth={`${DATE_PICKER_SUGGEST_BOX_WIDTH_PX}px`}
          selectedDate={pickerSelectedDate()}
          minimumDate={maxDate && (maxDate as any).toDate()}
          maximumDate={new Date()}
          onChange={handleDateChange}
          timeIntervals={is30MinAgency ? 30 : 15}
        />
        {canEditVisitType && (
          <>
            <TextDiv>{defaults.visitType}</TextDiv>
            <SmallDiv align="left" width={180}>
              <SuggestBox
                fitcontent
                options={visitTypeOptions || []}
                value={visitTypeOption}
                onChange={onVisitTypeChange}
                // className={classes.inputBase}
              />
            </SmallDiv>
          </>
        )}
      </VisitInterfaceDiv>
    </EditDateDiv>
  );
};
export default EditDate;
